import { Organization } from '../OrganizationTypes';
import { GetAvatarResponse } from './sharedTypes';

export type GetPublicOrganizationDetailsFromOrganizationClientInvitationResponse =
    | {
          type: 'available';
          details: Pick<Organization['metadata'], 'name' | 'description'>;
      }
    | {
          type: 'not-available';
      };

export type GetPublicOrganizationAvatarOrLogoFromOrganizationClientInvitationRequest = GetAvatarResponse | null;
